import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';
import { EnvironmentService } from 'src/app/services/environment.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FormatterData, InstallationFlowType } from 'src/app/constants/app.constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { ReviewSectionComponent } from 'src/app/+shared/components/review-section/review-section.component';
import { DrrCcdCommissioningData, DrrCcdDocumentTypes } from '../../technical-data/technical-data.domain';
import { FileEvent } from 'src/app/+shared/models/fileEvent';
import { parseBoolelanOrNull } from 'src/app/+shared/helpers/parsers.helper';

@Component({
  selector: 'app-drr-ccd-commissioning-data',
  templateUrl: './commissioning-data.component.html',
  styleUrls: ['./commissioning-data.component.scss'],
})
export class CcdDrrCommissioningDataComponent extends DestroyableComponent implements OnInit {
  public currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
  public installationFlowType = InstallationFlowType;
  public form: FormGroup;
  public sectionIdentifier = SectionIdentifier;
  public readonly dateFormat = FormatterData.date;

  constructor(public environmentService: EnvironmentService, private localStorageService: LocalStorageService) {
    super();
  }

  @Output() initForm = new EventEmitter<FormGroup>();
  @Input() data: DrrCcdCommissioningData;
  @Input() isDetailsView: boolean;
  @Input() applicationId: string | number;

  @ViewChild('reviewSection') reviewSection: ReviewSectionComponent;

  ngOnInit(): void {
    this.form = new FormGroup({
      is_commissioning_done: new FormControl(parseBoolelanOrNull(this.data?.is_commissioning_done), [Validators.required]),
      is_commissioning_confirmed: new FormControl(parseBoolelanOrNull(this.data?.is_commissioning_confirmed), [Validators.required]),
      commissioning_date: new FormControl(this.data?.commissioning_date, this.data?.is_commissioning_done ? [Validators.required] : []),
    });

    if (this.reviewSection && !this.reviewSection.isDataEditable) {
      this.form.disable();
    }

    this.initForm.emit(this.form);

    this.preventLeak(this.form.controls.is_commissioning_done.valueChanges).subscribe(value => {
      this.toggleCommissioningDate(value);
      this.removeCommissioningDocument(value);
    });
    this.preventLeak(this.form.controls.is_commissioning_confirmed.valueChanges).subscribe(value => {
      if (!value) {
        this.form.controls.is_commissioning_confirmed.setValue(null, { emitEvent: false });
      }
    });
  }

  public clearFile(fileEvent: FileEvent): void {
    if (!fileEvent.documentId) {
      return;
    }

    this.data.commissioning_document_id = null;
    this.data.commissioning_document = null;
  }

  fileFormInited(file: FormGroup) {
    this.form.addControl(DrrCcdDocumentTypes.CommissioningDocument, file);
  }

  private toggleCommissioningDate(isCommissioningDone: boolean) {
    const commissioningDateControl = this.form.controls.commissioning_date as FormControl;
    if (isCommissioningDone) {
      if (commissioningDateControl.disabled) {
        commissioningDateControl.enable({ emitEvent: false });
      }
      commissioningDateControl.setValidators([Validators.required]);
    } else {
      if (commissioningDateControl.enabled) {
        commissioningDateControl.disable({ emitEvent: false });
      }
      if (commissioningDateControl.value) {
        commissioningDateControl.setValue(null);
      }
    }
  }
  private removeCommissioningDocument(isCommissioningDone: boolean) {
    if (!isCommissioningDone) {
      this.form.removeControl(DrrCcdDocumentTypes.CommissioningDocument);
    }
  }
}
